import { GroupedAssessment } from '~/lib/types/survey/GroupedAssessment';
import OverdueAssessmentCard from './OverdueAssessmentsCard';
import { EmptySectionCard, SkeletonLoader, Text } from '@equip.health/ui';

interface OverdueAssessmentsCardListProps {
  overdueAssessments: GroupedAssessment[];
  isLoading: boolean;
  admitDate: string;
  onClickCompleteTogether: (surveyResponse: SurveyResponse) => void;
}

export const OverdueAssessmentsCardList = ({
  overdueAssessments,
  isLoading,
  admitDate,
  onClickCompleteTogether,
}: OverdueAssessmentsCardListProps) => {
  if (isLoading) {
    return (
      <SkeletonLoader
        height="100px"
        id="patient-note-template-overdue-assessments-loading"
        width="100%"
      />
    );
  }

  if (overdueAssessments?.length === 0) {
    return (
      <EmptySectionCard
        caption="No core assessments are currently overdue"
        id="overdue-card"
      />
    );
  }

  return (
    <>
      <Text color="neutral.secondary" maxW="350px" variant="caption">
        Consider using 10-15 minutes at the start of the session for the patient
        to complete overdue core assessments.
      </Text>
      {overdueAssessments.map((groupedAssessment) => (
        <OverdueAssessmentCard
          admitDate={admitDate}
          groupedAssessment={groupedAssessment}
          key={groupedAssessment.externalId}
          onClickCompleteTogether={onClickCompleteTogether}
        />
      ))}
    </>
  );
};
